import type { ExtensionConfig } from '@goto/shell-common'

const contactCenterSupervisorBaseUrl = '/experiences/cc-supervisor/'

const extensionConfig: ExtensionConfig = {
  id: '@ucc/cc-supervisor',
  url: new URL(`${contactCenterSupervisorBaseUrl}@ucc/cc-supervisor-extension.mjs`, location.origin),
  esModule: true,
  prerequisites: {
    ccFlags: 'cc-supervisor',
  },
  integrations: {
    msTeams: {
      shouldLoadInIntegration: true,
      shouldLoadInCompanion: true,
    },
    sidePanel: {
      shouldLoad: true,
    },
  },
  dependencies: ['@ucc/contact-center'],
}

export default extensionConfig
